module.exports = __webpack_public_path__ + "static/media/farmfresh.a58f37d5.png";